import Hero from '../../components/Hero'
import './CommercialIndustrialResidential.css'

const CommercialIndustrialResidential = () => {
  return (
    <>
      <Hero 
        title="Commercial & Industrial"
        subtitle="Tailored solutions for commercial buildings and industrial facilities."
        backgroundImage="/sectors/commercial/commercial.png"
        height="55.78125vh"
      />
      
      <section>
        <div className="section-header">
          <h2>Sector Overview</h2>
        </div>
        <p>Every site is unique, and our experienced teams design cleaning programs that align with your operational needs and regulatory requirements. Whether you manage a bustling office block or a busy manufacturing plant, we have the knowledge and resources to keep your commercial and industrial environments spotless, safe and productive.</p>
        <div className="cir-grid">
          <article>
            <h3>Commercial Facilities</h3>
            <p>Cleaning services for office buildings, corporate headquarters, retail centres and educational campuses to ensure a professional, hygienic atmosphere.</p>
          </article>
          <article>
            <h3>Industrial Facilities</h3>
            <p>Specialised cleaning for factories, warehouses and production plants that prioritises safety, compliance and minimal downtime.</p>
          </article>
          <article>
            <h3>Manufacturing &amp; Production</h3>
            <p>Specialised cleaning for manufacturing facilities, production lines and industrial equipment, ensuring compliance with safety standards and minimal operational disruption.</p>
          </article>
          <article>
            <h3>Warehouse &amp; Distribution</h3>
            <p>Comprehensive cleaning services for warehouses, distribution centers and logistics facilities, maintaining clean and safe working environments for staff and operations.</p>
          </article>
        </div>
      </section>
      
      <section className="cta-section">
        <h2>Transform Your Commercial & Industrial Space</h2>
        <p>From office buildings to large industrial complexes, we have the expertise to deliver exceptional results. Let's work together to raise the standard of cleanliness across your commercial and industrial sites.</p>
        <a className="cta-button" href="/contact">Enquire Now</a>
      </section>
    </>
  )
}

export default CommercialIndustrialResidential
